var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.99854,
    width: 20,
    height: 20,
    rx: 2,
    fill: "#2070EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65231 12.5383C7.12196 11.9019 6.17612 11.8159 5.5397 12.3462C4.90328 12.8766 4.8173 13.8224 5.34764 14.4589L7.84764 17.4589C8.37581 18.0927 9.31668 18.1809 9.95354 17.6565L18.4535 10.6565C19.093 10.1298 19.1845 9.1845 18.6579 8.54502C18.1312 7.90553 17.1859 7.81405 16.5464 8.34068L9.1976 14.3926L7.65231 12.5383Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.712fab5cee043860a1ce440e0ce5eade.svg";
export { ForwardRef as ReactComponent };